// @flow
/**
 * User: Mike Chung
 * Date: 21/1/2018
 * Time: 12:06 AM
 */


import type {EBadgeUnlockActionCollection, EBadgeUnlockModalActionCollection} from "../actions/ebadge/eBadgeUnlockAction";
import type {EBadgeLockActionCollection, EBadgeLockModalActionCollection} from "../actions/ebadge/eBadgeLockAction";
import type {CloseEBadgeButtonActionModalAction, EBadgeButtonActionActionCollection} from "../actions/ebadge/eBadgeButtonAction";

export type EBadgeActionState = {

    unlock: {

        [registrationCode: string]: {
            isLoading: boolean
        },
        error?: any,
        modal: {
            open: boolean,
            registrationCode?: string
        }
    },
    lock: {


        [registrationCode: string]: {
            isLoading: boolean
        },
        error?: any,
        modal: {
            open: boolean,
            registrationCode?: string
        }
    },
    [actionType: string]: {
        [registrationCode: string]: {
            isLoading: boolean
        },
        error?: any
    }
};

const INITIAL_STATE: EBadgeActionState = {
    unlock: {

        modal: {
            open: false
        }
    },
    lock: {

        modal: {
            open: false
        }
    }
};

type ActionCollection = EBadgeUnlockActionCollection | EBadgeUnlockModalActionCollection | EBadgeLockActionCollection | EBadgeLockModalActionCollection
    | EBadgeButtonActionActionCollection | CloseEBadgeButtonActionModalAction;

export default function reducer(state: EBadgeActionState = INITIAL_STATE, action: ActionCollection): EBadgeActionState {

    let result = {
        ...state
    };
    switch (action.type) {
        case "ebadge/BUTTON_ACTION_START_ACTION":
            result[action.actionType] = result[action.actionType] || {};
            result[action.actionType][action.registrationCode] = {
                isLoading: true
            };
            return result;
        case "ebadge/BUTTON_ACTION_SUCCESS_ACTION":
            result[action.actionType] = result[action.actionType] || {};
            result[action.actionType][action.registrationCode] = {
                isLoading: false
            };
            return result;
        case "ebadge/BUTTON_ACTION_FAILED_ACTION":
            result[action.actionType] = result[action.actionType] || {};
            result[action.actionType][action.registrationCode] = {
                isLoading: false
            };
            result[action.actionType].error = action.error;
            return result;
        case "ebadge/HIDE_BUTTON_ACTION_MODAL":
            result[action.actionType] = result[action.actionType] || {};
            result[action.actionType].error = undefined;
            return result;
        case "ebadge/UNLOCK_START_ACTION":
            result.unlock[action.registrationCode] = {
                isLoading: true
            };
            return result;
        case "ebadge/UNLOCK_SUCCESS_ACTION":
            result.unlock[action.registrationCode] = {
                isLoading: false
            };
            result.unlock.modal = {
                open: false
            };
            return result;
        case "ebadge/UNLOCK_FAILED_ACTION":
            result.unlock[action.registrationCode] = {
                isLoading: false
            };
            result.unlock.error = action.error;
            result.unlock.modal = {
                open: true
            };
            return result;
        case "ebadge/SHOW_UNLOCK_MODAL":
            return {
                ...state,
                unlock: {

                    modal: {
                        open: true,
                        registrationCode: "" + action.registrationCode
                    }
                }
            };
        case "ebadge/HIDE_UNLOCK_MODAL":
            return {
                ...state,
                unlock: {
                    modal: {
                        open: false
                    }
                }
            };
        case "ebadge/LOCK_START_ACTION":
            result.lock[action.registrationCode] = {
                isLoading: true
            };
            return result;
        case "ebadge/LOCK_SUCCESS_ACTION":
            result.lock[action.registrationCode] = {
                isLoading: false
            };
            result.lock.modal = {
                open: false
            };
            return result;
        case "ebadge/LOCK_FAILED_ACTION":
            result.lock[action.registrationCode] = {
                isLoading: false
            };
            result.lock.error = action.error;
            result.lock.modal = {
                open: true
            };
            return result;
        case "ebadge/SHOW_LOCK_MODAL":
            return {
                ...state,
                lock: {

                    modal: {
                        open: true,
                        registrationCode: "" + action.registrationCode
                    }
                }
            };
        case "ebadge/HIDE_LOCK_MODAL":
            return {
                ...state,
                lock: {
                    modal: {
                        open: false
                    }
                }
            };
        default:
            return state;
    }

}


// WEBPACK FOOTER //
// ./src/reducers/EBadgeActionReducer.js